import React from 'react';

import { connect } from 'react-redux';

class FilterIcon extends React.Component {
  render() {
    return (
      <svg>
        <path
     d="m 42.500002,7.3348007 c 0,-3.6768002 -10.0616,-5.6000003 -20.000001,-5.6000003 -9.938401,0 -20.0000008,1.9232001 -20.0000008,5.6000003 0,0.8336001 0.5216,1.5760002 1.4368001,2.2272002 l 13.7632007,18.8336001 0,14.020001 0.0496,0.8496 0.8,0 0.3656,-0.0144 8.3848,-8.3848 0,-6.470401 13.762401,-18.8336001 c 0.916,-0.6512 1.4376,-1.3936001 1.4376,-2.2272002 z M 22.500001,3.3348005 c 11.232001,0 18.400001,2.3688002 18.400001,4.0000002 0,1.6312002 -7.168,4.0000003 -18.400001,4.0000003 -11.232001,0 -18.4000007,-2.3688001 -18.4000007,-4.0000003 0,-1.6312 7.1679997,-4.0000002 18.4000007,-4.0000002 z"
     id="path3"
       fill={this.props.color || "#DE171F"}
       />
      </svg>
    );
  }
}

function mapStateToProps(state) {
  return {
    color: state.rr360.theme.primaryColor
  };
}


export default connect(mapStateToProps, undefined)(FilterIcon);



// WEBPACK FOOTER //
// ./src/icons/filter.js